<template>
  <van-popup
      v-model="showPopup"
      round
      position="bottom"
      closeable
      close-icon-position="top-right"
      :close-on-click-overlay="false"
      @closed="resetForm"
  >
    <div class="modal-container">
      <div class="modal-title">活动核销</div>
      <van-form @submit="onSubmit">
        <div style="text-align: center; margin: 20px 0;">
          <div style="width: 200px; height: 200px; background-color: #f5f5f5; border-radius: var(--radius-md); margin: 0 auto; display: flex; flex-direction: column; align-items: center; justify-content: center; color: var(--text-light);">
            <div style="font-size: 40px; margin-bottom: 10px;">📷</div>
            <div>点击扫描二维码</div>
          </div>
        </div>
        <van-field
            v-model="form.deviceNumber"
            name="deviceNumber"
            label="核销码"
            placeholder="请输入核销码"
            :rules="[{ required: true, message: '请输入核销码' }]"
        />
        <van-field
            v-model="form.deviceNumber"
            name="deviceNumber"
            label="客户手机号"
            placeholder="请输入客户手机号"
            :rules="[{ required: true, message: '请输入客户手机号' }]"
        />
        <van-field
            v-model="form.faultDescription"
            name="faultDescription"
            label="备注"
            type="textarea"
            placeholder="请输入备注信息(选填)"
            rows="3"
            autosize
        />
        <div class="form-buttons">
          <van-button round block plain type="default" native-type="button" @click="cancel">取消</van-button>
          <van-button round block type="primary" color="#e62d2d" native-type="submit">核销</van-button>
        </div>
      </van-form>
    </div>
  </van-popup>
</template>

<script>
import * as imageConversion from "image-conversion";
export default {
  name: 'activeVerify',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showPopup: this.value,
      showDeviceTypePicker: false,
      showFaultTypePicker: false,
      showUrgencyPicker: false,
      form: {
        deviceType: '',
        deviceNumber: '',
        faultType: '',
        faultDescription: '',
        urgency: '',
        images: []
      },
      deviceTypeOptions: [
        {id:1,text:'福彩销售终端机'},
        {id:2,text:'票据打印机'},
        {id:3,text:'条码扫描器'},
        {id:4,text:'其他设备'}
      ],
      faultTypeOptions: [
        {id:1,text:'无法开机'},
        {id:2,text:'打印故障'},
        {id:3,text:'网络连接问题'},
        {id:4,text:'系统错误'},
        {id:5,text:'其他故障'}
      ],
      urgencyOptions: [
        {id:1,text:'一般'},
        {id:2,text:'紧急'},
        {id:3,text:'非常紧急'}
      ],
      fileList:[],
      subFlag:false,
    }
  },
  watch: {
    value(val) {
      this.showPopup = val
    },
    showPopup(val) {
      this.$emit('input', val)
    }
  },
  methods: {
    beforeRead(file) {
      //如果开启的是多个图片上传就用这个循环压缩
      if (file instanceof Array) {
        return new Promise(async (resolve, reject) => {
          let newarr = [];
          //console.log(file)
          // 500是控制压缩大小的 根据你自己的需要调整 数值越小压缩越小
          for (const i in file) {
            //console.log('压缩前', file[i]) // 压缩到400KB,大于400KB的图片都会进行压缩，小于则不会
            const res = await imageConversion.compressAccurately(file[i], 300)
            //console.log(res)
            const newfile = new File([res], file[i].name, { type: res.type, lastModified: Date.now() })
            //console.log(newfile)
            newarr[i] = newfile
          }
          resolve(newarr)
        })
      } else {
        //单个就用这个
        return new Promise((resolve, reject) => {
          // console.log('压缩前', file) // 压缩到400KB,大于400KB的图片都会进行压缩，小于则不会
          // 500是控制压缩大小的 根据你自己的需要调整 数值越小压缩越小
          imageConversion.compressAccurately(file, 300).then(res => {
            res = new File([res], file.name, { type: res.type, lastModified: Date.now() })
            //console.log('压缩后', res)
            resolve(res)
          })
        })
      }
    },
    // 组件方法 获取 流
    afterRead(file) {
      if(file.length>0){
        file.map((v)=>{
          setTimeout(() => {
            this.postImg(v.content)
          }, 1000);
        })
      }else{
        this.postImg(file.content);
      }
    },
    // 提交图片到后端
    postImg(base64) {
      // this.subFlag = false;
      // this.$http.file_upload({
      //   content:base64
      // }).then((res)=>{
      //   this.res = res;
      //   if(res&&res.success){
      //     let str = "http://";
      //     let flag = res.retObj.indexOf(str) != -1;
      //     if(res.retObj&&flag){
      //       this.subFlag = true;
      //     }
      //   }
      // })
    },
    onDeviceTypeConfirm(value) {
      this.form.deviceType = value.text;
      this.showDeviceTypePicker = false;
    },
    onFaultTypeConfirm(value) {
      this.form.faultType = value.text;
      this.showFaultTypePicker = false;
    },
    onUrgencyConfirm(value) {
      this.form.urgency = value.text;
      this.showUrgencyPicker = false;
    },
    onSubmit() {
      this.$emit('submit', { ...this.form })
    },
    cancel() {
      this.showPopup = false
    },
    resetForm() {
      this.form = {
        deviceType: '',
        deviceNumber: '',
        faultType: '',
        faultDescription: '',
        urgency: '',
        images: []
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
